const initVerticalTabsBanner = () => {
  const component = document.querySelector('.vertical-tabs-banner');

  if (!component) {
    return;
  }

  const tabs = component.querySelectorAll('.vertical-tabs-banner__tab');
  const panels = component.querySelectorAll('.vertical-tabs-banner__panel');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;

      tabs.forEach(item => item.classList.remove('is-active'));
      panels.forEach(panel => panel.classList.remove('is-active'));

      tab.classList.add('is-active');

      const activePanel = component.querySelector(
        `[data-content="${target}"]`
      );

      if (activePanel) {
        activePanel.classList.add('is-active');
      }
    });
  });
};

document.addEventListener('DOMContentLoaded', initVerticalTabsBanner);